import React, { useEffect, useState } from "react";

const sdgTypes = [
  { name: "no poverty", value: "sdg-1", src: "/images/sdgs/1.png" },
  { name: "zero hunger", value: "sdg-2", src: "/images/sdgs/2.png" },
  {
    name: "good health & well-being",
    value: "sdg-3",
    src: "/images/sdgs/3.png",
  },
  { name: "quality education", value: "sdg-4", src: "/images/sdgs/4.png" },
  { name: "gender equality", value: "sdg-5", src: "/images/sdgs/5.png" },
  {
    name: "clean water & sanitation",
    value: "sdg-6",
    src: "/images/sdgs/6.png",
  },
  {
    name: "affordable & clean energy",
    value: "sdg-7",
    src: "/images/sdgs/7.png",
  },
  {
    name: "decent work & economic growth",
    value: "sdg-8",
    src: "/images/sdgs/8.png",
  },
  {
    name: "industry, innovation and infrastucture",
    value: "sdg-9",
    src: "/images/sdgs/9.png",
  },
  { name: "reduced inequilities", value: "sdg-10", src: "/images/sdgs/10.png" },
  {
    name: "sustainable cities & communities",
    value: "sdg-11",
    src: "/images/sdgs/11.png",
  },
  {
    name: "responsible consumption & production",
    value: "sdg-12",
    src: "/images/sdgs/12.png",
  },
  { name: "climate change", value: "sdg-13", src: "/images/sdgs/13.png" },
  { name: "life below water", value: "sdg-14", src: "/images/sdgs/14.png" },
  { name: "life on land", value: "sdg-15", src: "/images/sdgs/15.png" },
  {
    name: "peace, justice and strong institutions",
    value: "sdg-16",
    src: "/images/sdgs/16.png",
  },
  {
    name: "partnerships for the goals",
    value: "sdg-17",
    src: "/images/sdgs/17.png",
  },
];

const ViewSdgContribution = ({ selected }) => {

  const FindSdgIndex = ({ name }) => {
    let sdgDetails = sdgTypes.find((sdg) => sdg.value === name);
    if(!sdgDetails){
        return <></>
    }

    return (
      <>
        {/* Tooltip label */}
        <div className="absolute top-[-60px] left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-[9px] bg-gray-800 text-white p-1 rounded">
          {sdgDetails.name}
        </div>

        {/* SDG Image with border on select */}
        <div
          style={{
            background: `url(${sdgDetails.src})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
          }}
          className={`w-full h-full `}
        />
      </>
    );
  };

  return (
    <div className="flex mt-10 gap-3 max-w-5xl">
      {selected.map((name, index) => (
        <div
          key={`sdg-item-${index}`}
          className="relative w-12 h-12  cursor-pointer group"
        >
          <FindSdgIndex name={name} />
        </div>
      ))}
    </div>
  );
};

export default ViewSdgContribution;
